import { useQuery } from "@tanstack/react-query"
// api
import { USER_NOTIFICATIONS, getUserUnreadNotification, GetUserUnreadNotificationResponse } from "api"
import { useTranslation } from "react-i18next"
import { Language } from "types/i18n"

interface IUseUnreadNotification {
  disabled?: boolean
}

export const useUnreadNotification = ({ disabled = false }: IUseUnreadNotification) => {
  const { i18n } = useTranslation()

  const { data: fetchedUserUnreadNotifications } = useQuery<GetUserUnreadNotificationResponse>({
    enabled: !disabled,
    queryKey: [USER_NOTIFICATIONS.GET_USER_UNREAD_NOTIFICATION],
    queryFn: () => getUserUnreadNotification(i18n.language.slice(0, 2) as Language),
  })

  return {
    haveUnreadNotification: fetchedUserUnreadNotifications?.data[0]?.isRead === false,
  }
}
